import { CustomMentions } from './custom-mention';

export * from './custom-mention';

export default CustomMentions;
